import './lib/polyfills';
import Viewport from '@vaersaagod/tools/Viewport';
import Components from '@vaersaagod/tools/Components';
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import lazySizes from './lib/lazysizes';
import ViewportHeight from './lib/ViewportHeight';

gsap.defaults({ overwrite: 'auto' });

const init = () => {
    gsap.registerPlugin(ScrollToPlugin);
    Viewport.init();
    Components.init();
    Viewport.initTabbing();
    ViewportHeight.init();
    lazySizes.init();
};

require('doc-ready')(init);
